import React from 'react';
import { User } from 'lucide-react';
import { formatDate } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';

export default function ProfileTab({ user, org, stats }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base flex items-center gap-2">
          <User className="w-5 h-5 text-[#D94E18]" />
          Profile
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div><p className="text-xs text-zinc-500 mb-0.5">Email</p><p className="text-sm font-medium">{user?.email}</p></div>
          <div><p className="text-xs text-zinc-500 mb-0.5">Role</p><p className="text-sm font-medium">{user?.role === 'owner' ? 'Owner' : user?.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : 'Member'}</p></div>
          <div><p className="text-xs text-zinc-500 mb-0.5">Member since</p><p className="text-sm font-medium">{formatDate(user?.created_at)}</p></div>
          <div><p className="text-xs text-zinc-500 mb-0.5">Entity Type</p><Badge variant="outline">{org?.entity_type ? org.entity_type.charAt(0).toUpperCase() + org.entity_type.slice(1) : 'Not set'}</Badge></div>
        </div>
        {stats && (
          <div className="mt-6 p-4 bg-zinc-50 rounded-lg">
            <p className="text-xs font-medium text-zinc-500 uppercase tracking-wider mb-3">System Overview</p>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
              <div><p className="text-zinc-500">Transactions</p><p className="font-mono font-semibold">{stats.transactions?.total || 0}</p></div>
              <div><p className="text-zinc-500">Journal Entries</p><p className="font-mono font-semibold">{stats.journal_entries || 0}</p></div>
              <div><p className="text-zinc-500">Accounts</p><p className="font-mono font-semibold">{stats.accounts || 0}</p></div>
              <div><p className="text-zinc-500">Documents</p><p className="font-mono font-semibold">{stats.source_documents || 0}</p></div>
            </div>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
